import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H4R } from "typography/headers";

const SubHeader: React.FC = ({ children }) => {
  return <SubHeaderWrapper>{children}</SubHeaderWrapper>;
};

const SubHeaderWrapper = styled(H4R)`
  padding-top: 4px;
  color: ${color.neutral[400]};

  em {
    font-style: normal;
    color: ${color.neutral[500]};
  }
`;

export default SubHeader;
